<!--下载插件-->
<template>
  <div class="help_info_home">
    <!-- <div class="content-header" style="border: none;">
      <div class="left">
        <span class="title">通知中心</span>
      </div>
    </div> -->
    <div class="help_content">
      <div class="l_box">
        <div class="top_title">
          <div>
            {{ data.title }}
            <div class="time">创建时间:{{ data.create_time }}</div>
          </div>
          <Button type="primary" @click="$router.back()">返回</Button>
        </div>
        <div class="content-box" v-html="data.content">{{ data.content }}</div>
        <div class="accessory" v-if="data.file_list">
          <img src="../../../../../assets/images/accessory.png" class="icon" />
          <div class="list">
            <div v-for="(i, k) in data.file_list" :key="k">
              <a :href="i" target="_blank">{{ getFilenameFromUrl(i) }}</a>
            </div>
          </div>
        </div>
        <div class="footer-box">
          <!-- <div class="read_num">阅读 {{ data.see }}</div> -->
          <div class="control-box">
            <div class="item" v-if="up_title" @click="onItemClick(null, 'true')">
              <Icon type="md-arrow-back" size="20" />
              <div style="text-align: right">
                <div class="up">上一篇</div>
                <div>{{ up_title }}</div>
              </div>
            </div>
            <div class="item" v-if="down_title" @click="onItemClick(null, 'false')">
              <div>
                <div class="up">下一篇</div>
                <div>{{ down_title }}</div>
              </div>
              <Icon type="md-arrow-forward" size="20" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      data: {},
      info: '<div>123</div><input placeholder="从文档中搜寻答案"/>',
      List: [],
      up_title: null,
      up_id: null,
      down_title: null,
      down_id: null,
      isUse: '-1',
      id: '',
      catId: ''
    }
  },
  mounted () {
    this.id = this.$route.query.id
    this.getData()
    this.getList()
  },
  methods: {
    ...mapActions(['GetNoticeDetail', 'GetNoticeList']),
    getData () {
      this.GetNoticeDetail({ id: this.id }).then((res) => {
        this.data = res.data
        this.data.create_time = this.$moment(res.data.create_time)
        this.data.file_list = res.data.file_list
          ? res.data.file_list.split(',')
          : undefined
      })
    },
    getList () {
      this.GetNoticeList({ p: 0, l: 100 }).then((res) => {
        this.List = res.data.list
        console.log('数据', res.data)
        let current = 0
        this.List.map((item, index) => {
          if (item.id == this.id) {
            current = index
          }
        })
        console.log('当前index', current)
        this.up_title = null
        if (current) {
          this.up_title = this.List[current - 1].title
          this.up_id = this.List[current - 1].id
          if (current < this.List.length - 1) {
            this.down_title = this.List[current + 1].title
            this.down_id = this.List[current + 1].id
          } else {
            this.down_title = null
          }
        } else {
          this.down_title = this.List[current + 1].title
          this.down_id = this.List[current + 1].id
        }
      })
    },
    onItemClick (item, isUp) {
      console.log('id', this.up_id, this.down_id)
      this.$router.replace({
        path: '/notice/info',
        query: {
          id: isUp == 'true' ? this.up_id : this.down_id,
          _t: new Date().getTime()
        }
      })
      // this.$router.replace({ path: '/current-path', query: { ...this.$route.query, _t: new Date().getTime() } });
    },
    // 从URL中提取文件名
    getFilenameFromUrl (url) {
      var index = url.lastIndexOf('/')
      if (index > -1) {
        return decodeURIComponent(url.substring(index + 1))
      }
      return decodeURIComponent(url)
    }
  },
  watch: {
    $route (to, from) {
      // 当路由变化时执行，包括参数变化
      if (to.path === from.path) {
        this.id = to.query.id
        console.log('路由参数变化', this.id)
        // 执行获取数据的逻辑
        this.getData()
        this.getList()
      }
    }
  }
}
</script>
<style lang="less">
@import "./index.less";
</style>
